import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p>© 2025 L&B GenAI KrishiTech | MSME Registered | Built with ❤️ for India</p>
    </footer>
  );
}

export default Footer;

